import React, { useEffect, useState } from 'react';

import PageLayout from 'components/layouts/PageLayout';
import styled from 'styled-components';
// import Item from './Item';
import { listings } from 'types/dummy';
import Text from 'components/commons/Text';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Row } from 'saladsoft-primitive';
import { AdminOptionDto } from 'services/data-contracts';
import OptionCard from 'components/pages/options/OptionCard';
import ServiceHelper from 'stores/ServiceHelper';
import SimpleOptionCard from 'components/pages/listings/SimpleOptionCard';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import { useStoreWrapper } from 'stores/StoreHelper';
import OptionsList from 'components/pages/listings/OptionsList';
import { toast } from 'react-toastify';
import AdditionalOptionContainer from 'components/pages/listings/AdditionalOptionContainer';
import { useStateContext } from 'providers/usePageState';

const AdditionalOptionsPage = () => {
  const { listingId } = useParams();
  const { uiStore } = useStoreWrapper();

  const { broadcast } = useStateContext();

  const [options, setOptions] = useState<AdminOptionDto[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<AdminOptionDto[]>([]);

  const PageTitle = () => {
    return (
      <Row gap="10px">
        <Text type="H2">옵션 지정하기</Text>
        {/* <Text type="H4">{options?.length}개의 선택 가능한 옵션이 있습니다.</Text> */}
      </Row>
    );
  };

  // const handleRemoveOptions = () => {
  //   uiStore?.confirm.show({
  //     title: '정말 제거하시겠습니까?',
  //     onConfirmed: () => {
  //       // 현재 options에서 selectedOptions에 있는 항목들을 제외한 새로운 배열 생성
  //       const remainingOptions = options.filter(
  //         (option) => !selectedOptions.some((selected) => selected.id === option.id),
  //       );
  //       const optionIds = remainingOptions.map((option) => option.id);

  //       ServiceHelper.adminListingService
  //         ?.saveOptions(Number(listingId), optionIds as number[])
  //         .then((res) => {
  //           toast.success('옵션이 제거되었습니다.');
  //           fetchOptions();
  //           setSelectedOptions([]); // 선택된 옵션 초기화
  //           broadcast({ id: 'reload', param: 'option' });
  //         });
  //     },
  //   });
  // };

  // const handleSelectOption = (option: AdminOptionDto, checked: boolean) => {
  //   if (checked) {
  //     // 옵션이 선택된 경우, selectedOptions 배열에 추가
  //     setSelectedOptions((prev) => [...prev, option]);
  //   } else {
  //     // 옵션이 해제된 경우, selectedOptions 배열에서 제거
  //     setSelectedOptions((prev) => prev.filter((item) => item.id !== option.id));
  //   }
  // };

  // const handleAddOptions = () => {
  //   uiStore?.modal.show({
  //     title: '옵션추가',
  //     style: { width: '600px', maxHeight: '80%', height: 'auto' },
  //     children: <OptionsList checkedOptions={options} listingId={Number(listingId)} />,
  //     onConfirmed: () => {
  //       fetchOptions();
  //       broadcast({ id: 'reload', param: 'option' });
  //     },
  //   });
  // };

  // const fetchOptions = () => {
  //   ServiceHelper.adminListingService?.getOptionsByListing1(Number(listingId)).then((res) => {
  //     setOptions(res.data as AdminOptionDto[]);
  //     broadcast({ id: 'reload', param: 'option' });
  //   });
  // };

  // useEffect(() => {
  //   if (listingId) {
  //     fetchOptions();
  //   }
  // }, [listingId]);

  return (
    <PageLayout title={<PageTitle />}>
      <AdditionalOptionContainer />
    </PageLayout>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  > div {
    flex: 1 1 350px; // flex-basis를 350px로 설정
    min-width: 0;
    max-width: 400px;
    width: calc((100% - 40px) / 3); // 3개 아이템일 때의 최대 너비

    @media (max-width: 1200px) {
      width: calc((100% - 20px) / 2); // 2개 아이템일 때의 최대 너비
    }

    @media (max-width: 768px) {
      width: 100%; // 1개 아이템일 때의 너비
    }
  }
`;

const ItemContainer = styled.div`
  flex: 1 1 350px;
  min-width: 0;
  max-width: 400px;
  width: calc((100% - 40px) / 3);
  transition: transform 0.1s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 1200px) {
    width: calc((100% - 20px) / 2);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ItemLayout = styled.div`
  border-radius: 10px;
  overflow: hidden;
`;

export default AdditionalOptionsPage;
